<div
  class="camera-list"
  cdkDropList
  id="cameraSource"
  [cdkDropListData]="cameras"
  [cdkDropListConnectedTo]="connectedDropLists"
>
  <ng-container *ngFor="let camera of cameras; trackBy: trackById">
    <div
    cdkDrag
    cdkDragHandle
    cdkDragRootElement=".cdk-overlay-pane"
    [cdkDragData]="camera"
    (cdkDragStarted)="onDragStart(camera)"
    >
        <!-- <div class="drag-handle"  cdkDragHandle title="Drag"> </div> -->
        <div class="camera-info">
            <p class="cam-name">{{ camera.obj.name }}</p>
            <p class="separator">|</p>
            <p class="cam-details">{{ camera.obj.streamName }}</p>
        </div>    
    </div>
    <hr class="divider" />
  </ng-container>
</div>
